export default __webpack_public_path__ + "static/media/port.20c9014b.png";